const ChevronUp: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <path
        d="M14.7236 14.2242C14.5153 14.4048 14.2792 14.4985 14.0153 14.5055C13.7514 14.5124 13.5223 14.4187 13.3278 14.2242L9.91114 10.8076L6.47364 14.2451C6.29309 14.4256 6.06045 14.5124 5.77573 14.5055C5.491 14.4985 5.25837 14.4048 5.07781 14.2242C4.86948 14.0159 4.76878 13.7833 4.77573 13.5263C4.78267 13.2694 4.88337 13.0437 5.07781 12.8492L9.22364 8.70339C9.32087 8.60617 9.4285 8.53325 9.54656 8.48464C9.66462 8.43603 9.78614 8.41172 9.91114 8.41172C10.0361 8.41172 10.1577 8.43603 10.2757 8.48464C10.3938 8.53325 10.5014 8.60617 10.5986 8.70339L14.7236 12.8284C14.9181 13.0228 15.0118 13.252 15.0049 13.5159C14.9979 13.7798 14.9042 14.0159 14.7236 14.2242Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ChevronUp;
